import React from 'react';

const Section = ({ children, style = '', isContainer = true, id }) => {
  return (
    <section id={id} className={`container-fluid ${style ?? ''}`}>
      {isContainer ? (
        <div className="container mx-auto">
          { children }
        </div>
      ) : (
        { children }
      )}
    </section>
  );
};

export default Section;
